import { Scanner } from "@yudiel/react-qr-scanner";
import { trackEvent } from "@/utils/firebase/analytics";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "@/ui/chakra/dialog";

export const ModalProductScanner = ({
  isOpen,
  onClose,
  onScan,
}: {
  isOpen: boolean;
  onClose: () => void;
  onScan: (data: { id: string }) => void;
}) => {
  return (
    <DialogRoot isOpen={isOpen} onClose={onClose} isCentered size="md">
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Escanear producto</DialogTitle>
        </DialogHeader>
        <DialogCloseTrigger />
        <DialogBody>
          <Scanner
            onScan={(detectedCodes) => {
              if (detectedCodes?.length === 0) return;

              const rawValue = detectedCodes?.at(-1)?.rawValue;

              if (!rawValue) return;

              const product = JSON.parse(rawValue) as { id: string };

              trackEvent("qr_scan", {
                module: "vouchers",
                product_id: product.id,
              });
              onScan(product);
            }}
            allowMultiple
          />
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};
